import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46ec6528"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "ログイン後ポップアップ通知一覧")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "chkkikan",
  class: "form-check-label",
  style: {"margin-right":"1rem"}
}, "表示期間外も表示する", -1))
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "table table-bordered" }
const _hoisted_11 = { class: "thead-light" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_btnUpdate" }, "編集", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_title" }, "タイトル", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_hyojiTaisho" }, "表示対象", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_checkPattern" }, "チェックパターン", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_checkHyoujiTaisho" }, "チェック表示対象", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_preview" }, "プレビュー", -1))
const _hoisted_19 = {
  "data-name": "mSelection",
  style: {"text-align":"center"}
}
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = {
  "data-name": "mBtnUpdate",
  style: {"text-align":"center"}
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  "data-name": "mDisapDate",
  style: {"text-align":"center"}
}
const _hoisted_24 = {
  "data-name": "mTitle",
  style: {"text-align":"left","padding-left":"8px"}
}
const _hoisted_25 = {
  "data-name": "mHyoujiTaisho",
  style: {"text-align":"left","padding-left":"8px"}
}
const _hoisted_26 = {
  "data-name": "mCheckHyoujiTaisho",
  style: {"text-align":"left","padding-left":"8px"}
}
const _hoisted_27 = {
  "data-name": "mCheckPattern",
  style: {"text-align":"left","padding-left":"8px"}
}
const _hoisted_28 = {
  "data-name": "mBtnUpdate",
  style: {"text-align":"center"}
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "form-inline flex-container" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_LoginPopupModalComponent = _resolveComponent("LoginPopupModalComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              id: "chkkikan",
              type: "checkbox",
              class: "form-check-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isUnlimitDate) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.isUnlimitDate]
            ]),
            _hoisted_8,
            _createElementVNode("button", {
              type: "button",
              name: "mBtnDisp",
              class: "btn btn-primary btn-sm",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickDisp && _ctx.onClickDisp(...args)))
            }, " 表示 "),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("thead", _hoisted_11, [
                  _createElementVNode("tr", null, [
                    _hoisted_12,
                    _hoisted_13,
                    _createElementVNode("th", {
                      class: _normalizeClass([
                  'col_hyojiKikan',
                  'sortable',
                  _ctx.isDirectionDesc('keisaiKikanStart') ? 'desc' : 'asc',
                ]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSortItem('keisaiKikanStart')))
                    }, " 表示期間 ", 2),
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popupDataList, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.contentsId
                    }, [
                      _createElementVNode("td", _hoisted_19, [
                        _withDirectives(_createElementVNode("input", {
                          id: "mSelection",
                          "onUpdate:modelValue": ($event: any) => ((item.selection) = $event),
                          type: "checkbox",
                          class: "form-check-input"
                        }, null, 8, _hoisted_20), [
                          [_vModelCheckbox, item.selection]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "mBtnUpdate",
                          class: "btn btn-primary btn-sm",
                          onClick: ($event: any) => (_ctx.showUpdate(item.contentsId))
                        }, " 編集 ", 8, _hoisted_22)
                      ]),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(item.dispDate), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(item.title), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(item.hyojiTaisho), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(item.checkPatarn), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(item.checkDispTarget), 1),
                      _createElementVNode("td", _hoisted_28, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "mBtnUpdate",
                          class: "btn btn-primary btn-sm",
                          onClick: ($event: any) => (_ctx.onPreviewLoginPopup(item.contentsId))
                        }, " プレビュー ", 8, _hoisted_29)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnDelete",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                  }, " 削除 ")
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                  }, " 戻る "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnAdd",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showAdd && _ctx.showAdd(...args)))
                  }, " 新規登録 ")
                ])
              ])
            ])
          ]),
          (_ctx.isOpenLoginPopupModal)
            ? (_openBlock(), _createBlock(_component_LoginPopupModalComponent, {
                key: 0,
                isOpen: _ctx.isOpenLoginPopupModal,
                categoryId: _ctx.previewCategoryId,
                contentsId: _ctx.previewContentsId,
                "is-preview": true,
                onClosed: _ctx.handleLoginPopupModalClosed
              }, null, 8, ["isOpen", "categoryId", "contentsId", "onClosed"]))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}